import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from 'src/app/app.settings';
import { lastValueFrom } from 'rxjs';
import { ErrorResp, MyReq } from '@robisoft/cross-library';
import { GetContactsReq, GetContactsResp } from '../models/Contact';
import { GetHotelInfoReq, GetHotelInfoResp, GetPacchettiReq, GetPacchettiResp, GetShopCartReq, GetShopCartResp } from '../models/Pacchetti';
import { GetPartenzaReq, GetPartenzaResp, GetPartenzeReq, GetPartenzeResp, GetPercorsiResp } from '../models/Percorso';
import { EliminaTeetimeReq, GetTeetimesReq, GetTeetimesResp, ModificaTeetimeReq } from '../models/Teetime';
import { DateTime } from 'luxon';


@Injectable({
  providedIn: 'root'
})
export class GolfService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    Pragma: 'no-cache'
  });

  constructor(private http: HttpClient) {

  }

  public async GetPartenze(req: GetPartenzeReq): Promise<GetPartenzeResp> {

    let resp: GetPartenzeResp | undefined = new GetPartenzeResp();

    try {
      resp = await lastValueFrom(this.http.post<GetPartenzeResp>(AppSettings.API_ENDPOINT + '/golf/get_partenze',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetPartenzeResp();
        resp.error = 'Non riesco a collegarmi al server (get_partenze)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new GetPartenzeResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_partenze) ' + err;
    }
    return resp;
  }

  public async GetPercorsi(req: MyReq): Promise<GetPercorsiResp> {

    let resp: GetPercorsiResp | undefined = new GetPercorsiResp();

    try {
      resp = await lastValueFrom(this.http.post<GetPercorsiResp>(AppSettings.API_ENDPOINT + '/golf/get_percorsi',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetPercorsiResp();
        resp.error = 'Non riesco a collegarmi al server (get_percorsi)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new GetPercorsiResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_percorsi) ' + err;
    }
    return resp;
  }

  public async GetPartenza(req: GetPartenzaReq): Promise<GetPartenzaResp> {

    let resp: GetPartenzaResp | undefined = new GetPartenzaResp();

    try {
      resp = await lastValueFrom(this.http.post<GetPartenzaResp>(AppSettings.API_ENDPOINT + '/golf/get_partenza',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetPartenzaResp();
        resp.error = 'Non riesco a collegarmi al server (get_partenza)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new GetPartenzaResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_partenza) ' + err;
    }
    return resp;
  }

  public async Prenota(req: GetShopCartReq): Promise<GetShopCartResp> {

    let resp: GetShopCartResp | undefined = new GetShopCartResp();

    try {
      resp = await lastValueFrom(this.http.post<GetShopCartResp>(AppSettings.API_ENDPOINT + '/golf/prenota_partenza',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetShopCartResp();
        resp.error = 'Non riesco a collegarmi al server (prenota_partenza)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new GetShopCartResp();
      }
      resp.error = 'Non riesco a collegarmi al server (prenota_partenza) ' + err;
    }
    return resp;
  }

  public async GetTeetimes(req: GetTeetimesReq): Promise<GetTeetimesResp> {

    let resp: GetTeetimesResp | undefined = new GetTeetimesResp();

    try {
      resp = await lastValueFrom(this.http.post<GetTeetimesResp>(AppSettings.API_ENDPOINT + '/golf/get_teetimes',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetTeetimesResp();
        resp.error = 'Non riesco a collegarmi al server (get_teetimes)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new GetTeetimesResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_teetimes) ' + err;
    }
    return resp;
  }

  public async EliminaTeetime(req: EliminaTeetimeReq): Promise<ErrorResp> {

    let resp: ErrorResp | undefined = new ErrorResp();

    try {
      resp = await lastValueFrom(this.http.post<ErrorResp>(AppSettings.API_ENDPOINT + '/golf/elimina_teetime',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (elimina_teetime)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (elimina_teetime) ' + err;
    }
    return resp;
  }

  public async InviaRichiesta(req: MyReq): Promise<ErrorResp> {

    let resp: ErrorResp | undefined = new ErrorResp();

    try {
      resp = await lastValueFrom(this.http.post<ErrorResp>(AppSettings.API_ENDPOINT + '/golf/invia_richiesta',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (invia_richiesta)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (invia_richiesta) ' + err;
    }
    return resp;
  }

  public async ModificaTeetime(req: ModificaTeetimeReq): Promise<ErrorResp> {

    let resp: ErrorResp | undefined = new ErrorResp();

    try {
      resp = await lastValueFrom(this.http.post<ErrorResp>(AppSettings.API_ENDPOINT + '/golf/modifica_teetime2',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (modifica_teetime2)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (modifica_teetime2) ' + err;
    }
    return resp;
  }

  public async GetPacchetti(req: GetPacchettiReq): Promise<GetPacchettiResp> {

    let resp: GetPacchettiResp | undefined = new GetPacchettiResp();

    try {
      resp = await lastValueFrom(this.http.post<GetPacchettiResp>(AppSettings.API_ENDPOINT + '/golf/get_pacchetti',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetPacchettiResp();
        resp.error = 'Non riesco a collegarmi al server (get_pacchetti)';
        return resp;
      }
      else {
        resp.pacchetti.forEach(pacchetto => {
          pacchetto.D.forEach(d => {
            if (d)
              d = DateTime.fromISO(d.toISO());
          });
        });
      }

    } catch (err) {
      if (!resp) {
        resp = new GetPacchettiResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_pacchetti) ' + err;
    }
    return resp;
  }

  public async GetHotelInfo(req: GetHotelInfoReq): Promise<GetHotelInfoResp> {

    let resp: GetHotelInfoResp | undefined = new GetHotelInfoResp();

    try {
      resp = await lastValueFrom(this.http.post<GetHotelInfoResp>(AppSettings.API_ENDPOINT + '/golf/get_hotel_info',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetHotelInfoResp();
        resp.error = 'Non riesco a collegarmi al server (get_hotel_info)';
        return resp;
      }

      if (!resp.gallery)
        resp.gallery = [];

    } catch (err) {
      if (!resp) {
        resp = new GetHotelInfoResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_hotel_info) ' + err;
    }
    return resp;
  }

  public async GetGolfclubs(req: GetContactsReq): Promise<GetContactsResp> {

    let resp: GetContactsResp | undefined = new GetContactsResp();

    try {
      resp = await lastValueFrom(this.http.post<GetContactsResp>(AppSettings.API_ENDPOINT + '/golf/get_golfclubs',
        JSON.stringify(req), { headers: this.headers }));

      if (!resp) {
        resp = new GetContactsResp();
        resp.error = 'Non riesco a collegarmi al server (get_golfclubs)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new GetContactsResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_golfclubs) ' + err;
    }
    return resp;
  }

}